<template>
  <div class="input-details-container" :class="[{ 'disabled': disabled }]">
    <label class="mb-1">{{ label }}</label>
    <div class="wrapper">
      <div v-if="prependIcon" class="prepend pr-2">
        <icon
          :name="prependIcon"
          :class="prependIconClass"
          style="color: var(--icon-primary)"
          @click="emit('click:prependIcon')"
        />
      </div>
      <vee-field
        v-model="inputValue"
        :name="name"
        :rules="rules"
        :type="type"
        :placeholder="placeholder"
        :disabled="disabled"
        :required="required"
        class="input-details"
        :autocomplete="autoComplete"
        @focusin="emit('focusin:input')"
        @blur="emit('blur:input')"
      />
      <slot name="append" />
    </div>
    <slot name="message" />
    <vee-error-message class="error-message-field" :name="name"/>
  </div>
</template>

<script setup lang="ts">
const inputValue = defineModel<string>()
const emit = defineEmits(['click:prependIcon', 'blur:input', 'focusin:input'])
defineProps({
  label: {
    type: String,
    required: true
  },
  placeholder: {
    type: String,
    default: ''
  },
  required: {
    type: Boolean,
    default: undefined
  },
  name: {
    type: String,
    required: true
  },
  rules: {
    type: String,
    default: undefined
  },
  type: {
    type: String,
    default: 'text'
  },
  disabled: {
    type: Boolean,
    default: undefined
  },
  prependIcon: {
    type: [String, null],
    default: undefined
  },
  prependIconClass: {
    type: String,
    default: undefined
  },
  autoComplete: {
    type: String,
    default: undefined
  }
})
</script>

<style lang="scss" scoped>
.input-details-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.wrapper {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    border: 1px solid var(--input-border);
    background-color: var(--input-primary);
    border-radius: 6px;

    .prepend {
      display: flex;
      align-items: center;
    }

    input {
      width: 100%;
      height: 100%;
      border: none;
      outline: none;
      background-color: var(--input-primary);
    }
}


.input-details-container.disabled {
  cursor: not-allowed;
  .wrapper {
    border: 1px solid  var(--button-border-disabled);
    background-color: var(--button-disabled);
    cursor: not-allowed;
  }

  input {
    cursor: not-allowed;
    background-color: var(--button-disabled);
  }
}

</style>
